import { type AnimationSequence, animate } from "motion";

const searchResultsElement = document.querySelector<HTMLElement>(
	".search-overlay .search-overlay__scrollbar-container .search-overlay__results-wrapper",
);
const overlay = document.querySelector<HTMLDialogElement>(".search-overlay");
const searchContainer = document.querySelector<HTMLElement>(".search-overlay .search");
export function clearResults() {
	if (!searchResultsElement) {
		console.warn("Search results element not found");
		return;
	}

	document.querySelector(".search form")?.classList.remove("has-results");

	hideSearchOverlayItems();
	hideSearchOverlayResults();

	document.querySelector(".search-overlay__scrollbar-container")?.replaceChildren();
}

export function hideSearchOverlay() {
	if (!overlay || !searchContainer) {
		console.warn("Search overlay dialog not found");
		return;
	}

	overlay.close();
}

export function showSearchOverlay() {
	if (!overlay || !searchContainer) {
		console.warn("Search overlay dialog not found");
		return;
	}

	overlay.show();
	document.body.appendChild(overlay);
}

export function hideSearchOverlayItems() {
	const searchItems = document.querySelectorAll<HTMLElement>(".search-overlay__result-item");
	if (!searchItems) {
		console.warn("Search items not found");
		return;
	}

	const animationSequence: AnimationSequence = [];

	searchItems.forEach((element) => {
		animationSequence.push([element, { opacity: [1, 0] }]);

		// animationSequence.push([element.querySelector<HTMLElement>('p')!, { opacity: [1, 0] }]);
	});

	animate(animationSequence);
}

export function showSearchOverlayItems() {
	const searchItems = document.querySelectorAll<HTMLElement>(".search-overlay__result-item");
	const searchResultsElement = document.querySelector<HTMLElement>(".search-overlay .search-overlay__results");
	if (!searchItems || !searchResultsElement) {
		console.warn("Search items or results element not found");
		return;
	}

	const animationSequence: AnimationSequence = [[searchResultsElement, { opacity: [0, 1], scaleY: [0, 1], transformOrigin: "top" }]];

	searchItems.forEach((element) => {
		animationSequence.push([element, { opacity: [0, 1] }]);

		const paragraph = element.querySelector<HTMLElement>("p");
		const image = element.querySelector<HTMLImageElement>("img");
		const price = element.querySelector<HTMLElement>("bdi");

		if (image) animationSequence.push([image, { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { at: "<" }]);
		if (paragraph) animationSequence.push([paragraph, { opacity: [0, 1] }, { at: "<" }]);
		if (price) animationSequence.push([price, { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { at: "<" }]);
	});

	animate(animationSequence);
}

export function hideSearchOverlayResults() {
	if (!searchResultsElement) {
		console.warn("Search results element not found");
		return;
	}

	return animate(searchResultsElement, { opacity: [1, 0] });
}
